const domain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')

export default {
    authority: 'https://soccercise.eu.auth0.com',
    client_id: 'sNGcAuBXHwArCoUWoXbsX864CSoW3IHf',
    redirect_uri: `${domain}/auth`,
    response_type: 'id_token token',
    scope: 'openid offline_access email profile soccerapi',
    post_logout_redirect_uri: 'https://www.soccerpresso.de',
    automaticSilentRenew: true,
    silent_redirect_uri: `${domain}/silent.html`,
    client_secret: 'n1wnmGCZk-ATadyissN6_tVXKExgWzK-JbG6m69zaFwH9SNzCJHP7qCMUf-T7Z7X',
    revokeAccessTokenOnSignout: true,

    extraQueryParams: { audience: 'soccerapi', prompt: 'select_account' }
}